<div class="card-container">
  <div class="column-headings">
    <div class="heading">BALANCE</div>
  </div>
  @for (entityAccount of currentPage().data; track entityAccount) {
    <a class="row">
      <app-entity-account-card [entityAccount]="entityAccount" (cardClicked)="handleCardClicked($event)"></app-entity-account-card>
    </a>
  }
</div>
